import { useState, useEffect } from "react";
import { Logo, LogoMobile } from "./Logo";
import { NavLink } from "react-router-dom";

interface NavProps {
  isMobile: boolean;
  closeMenu?: () => void;
}

const navItems = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About BStrong" },
  { to: "/bookshelf", label: "Bookshelf" },
  { to: "/contact", label: "Contact" },
];

function SiteNav({ isMobile, closeMenu }: NavProps) {
  const location = window.location.pathname;

  return (
    <>
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={`font_family_base ${
            isMobile
              ? `detail_text ${
                  location === item.to
                    ? "header-border-mobile header_border_mobile_color"
                    : ""
                }`
              : `text_1 ${
                  location === item.to
                    ? "header-border header_border_color"
                    : ""
                }`
          }`}
          onClick={isMobile ? closeMenu : undefined}
        >
          {item.label}
        </NavLink>
      ))}
    </>
  );
}

const DesktopHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className="top-nav row"
      style={{
        width: "calc(100% - 20px)",
        height: isScrolled ? "70px" : "140px",
        backgroundColor: isScrolled ? "rgba(11, 13, 16, 0.95)" : "transparent",
        transition: "background-color 0.3s ease, height 0.3s ease",
      }}
    >
      <div className="logo_left text_spacer">
        <NavLink to="/">
          <Logo large={!isScrolled} />
        </NavLink>
      </div>
      <div className="nav-content">
        <div className="nav-links">
          <SiteNav isMobile={false} />
        </div>
      </div>
      <div className="welcome_text" />
    </nav>
  );
};

const MobileHeader = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function toggleActive() {
    setMenuActive((menuActive) => !menuActive);
  }

  function closeMenu() {
    setMenuActive(false);
  }

  return (
    <nav
      className="top-nav"
      style={{
        width: "calc(100% - 20px)",
        backgroundColor: isScrolled ? "rgba(11, 13, 16, 0.95)" : "transparent",
        transition: "background-color 0.3s ease",
      }}
    >
      {menuActive && (
        <div
          onClick={closeMenu}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 998,
          }}
        />
      )}
      <div className="nav-content-mobile row">
        <div className="col4of10">
          <button
            className="hamburger"
            aria-label="Toggle menu"
            onClick={toggleActive}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
          <div
            className={`nav-links ${menuActive ? "active" : ""}`}
            style={{ zIndex: 999 }}
          >
            <SiteNav isMobile={true} closeMenu={closeMenu} />
          </div>
          <div className="left_spacer_big">
            <NavLink to="/" className="font_family_base">
              <LogoMobile />
            </NavLink>
          </div>
        </div>
        <div className="col6of10" />
      </div>
    </nav>
  );
};

export function PageNav() {
  return (
    <>
      <div className="show-desktop" style={{ padding: "0 10px" }}>
        <DesktopHeader />
      </div>
      <div className="show-mobile" style={{ padding: "0 10px" }}>
        <MobileHeader />
      </div>
    </>
  );
}
